import { useFormik } from 'formik'
import { Link } from 'react-router-dom'
import { FC } from 'react'
import * as Yup from 'yup'
import { AUTH_PATH } from '~/app/lib/paths'
import Button from '../../utils/Button/Button'
import Input from '../../utils/Input/Input'
import Text from '../../utils/Text/Text'
import { useForgotPassword } from '~/app/services/auth/auth.hook'
import Icon from '../../utils/Icon'

interface FormForgotPasswordProps {
  onSubmit: (email: string) => void
  email?: string
}

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
})

const FormForgotPassword: FC<FormForgotPasswordProps> = ({ onSubmit, email }) => {
  const { mutate, isPending } = useForgotPassword()
  const form = useFormik({
    enableReinitialize: true,
    validationSchema: ForgotPasswordSchema,

    initialValues: {
      email: email ?? '',
    },

    async onSubmit(values) {
      const email = values.email?.trim()
      mutate(email, {
        onSuccess() {
          onSubmit(email)
        },
      })
    },
  })

  return (
    <div className="space-y-7.5">
      <Text type="headline-4" color="800" className="w-full text-center">
        Forgot password
      </Text>
      <Text type="body-1" color="600" className="w-full text-center">
        Enter the email associated with your account to receive an instruction email to reset your
        password
      </Text>
      <div className="flex flex-col gap-6">
        <Input
          label="Email"
          required
          {...form.getFieldProps('email')}
          placeholder="Enter email"
          error={form.errors.email}
          onEnter={form.submitForm}
        />

        <Button onClick={form.submitForm} loading={isPending}>
          Send Link
        </Button>
      </div>
      <Link to={AUTH_PATH.SIGN_IN} className="flex-center">
        <Icon name="arrow-left-2" color="var(--primary)" size={24} className="mr-2" />
        <Text type="title-2" color="primary">
          Back to Sign in
        </Text>
      </Link>
    </div>
  )
}

export default FormForgotPassword
